<template>
  <PButton
    :as="is_upload ? 'a' : 'button'"
    :disabled="is_disabled || null"
    :size="size"
    variant="outlined"
    @click.stop="submit"
  >
    <div v-if="iconFontawesome">
      <FontAwesomeIcon
        :icon="iconFontawesome"
        :spin="iconFontawesome === 'spinner'"
      />
    </div>
    <div
      v-if="$slots.default && !hide_text"
      class="font-semibold"
    >
      <slot />
    </div>
  </PButton>
</template>

<script>
const actions_to_fontawesome_icon = Object.freeze({
  arrow_down: 'arrow-down',
  arrow_up: 'arrow-up',
  create: 'plus',
  download: 'download',
  downloading: 'spinner',
  edit: 'pen-to-square',
  preview: ['far', 'eye'],
  save: 'save',
  unpublish: ['far', 'eye-slash'],
  upload: 'upload',
  unlock: ['far', 'unlock'],
  share: 'share',
  template: ['far', 'memo'],
  new: 'plus',
  info: ['far', 'circle-info'],
  lock: ['far', 'lock'],
  settings: ['far', 'gear'],
});

export default {
  name: 'ButtonSecondary',
  props: {
    is_disabled: { type: Boolean },
    action: {
      type: String,
      default: null,
      validator: (prop) => Object.keys(actions_to_fontawesome_icon).includes(prop),
    },
    to: { type: Object, default: null },
    is_upload: { type: Boolean },
    is_outlined: { type: Boolean, default: true },
    size: { type: String, default: 'small' },
    is_color: { type: String, default: 'is-primary' },
    is_rounded: { type: Boolean, default: true },
    hide_text: { type: Boolean, default: false },
  },

  emits: ['onClick'],

  data() {
    return {
      iconFontawesome: null,
    };
  },

  watch: {
    action: {
      immediate: true,
      handler() {
        this.iconFontawesome = actions_to_fontawesome_icon[this.action];
      },
    },
  },

  methods: {
    submit(event) {
      if (this.is_disabled) return null;
      if (this.to) return this.$router.push(this.to);
      this.$emit('onClick', event);
      return null;
    },
  },
};
</script>
